import * as React from "react";
const SvgMale = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 17,
	height: 17,
	viewBox: "1 1 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M9.52872 5C9.28086 5 9.07995 5.20093 9.07995 5.44878C9.07995 5.69663 9.28086 5.89755 9.52872 5.89755H10.9227L9.61058 7.22822C8.37896 6.28536 6.60931 6.37729 5.4826 7.504C4.2558 8.73081 4.2558 10.7198 5.4826 11.9466C6.70941 13.1735 8.69844 13.1735 9.92526 11.9466C11.0366 10.8353 11.1412 9.09835 10.239 7.86929L11.5482 6.54149V7.69265C11.5482 7.94051 11.7491 8.14143 11.997 8.14143C12.2448 8.14143 12.4458 7.94051 12.4458 7.69265V5H9.52872ZM6.11727 11.312C6.99356 12.1883 8.41432 12.1883 9.2906 11.312C10.1669 10.4357 10.1669 9.01497 9.2906 8.13865C8.41432 7.26237 6.99356 7.26237 6.11727 8.13865C5.24098 9.01497 5.24098 10.4357 6.11727 11.312Z",
	fill: "currentColor"
}));
export default SvgMale;
